import api from "../api";

export default {
  namespaced: true,
  state: {
    accountPayeeList: {
      beanList: [],
      total: 0,
    },
  },
  mutations: {
    setStateAccountPayeeList(state, info) {
      state.accountPayeeList = info;
    },
  },
  actions: {
    getAccountPayeeList({ commit }, params) {
      return api
        .post(`/accountPayee/list`, "列出用户收款信息", params)
        .then((res) => {
          commit("setStateAccountPayeeList", res.data);
        });
    },
  },
};
